import { Navigate,useLocation } from 'react-router-dom';
import { canonicalEnglishPath } from '../lib/legacyPaths';

/** Legacy language pages contained English fallback content. Preserve their destinations. */
export default function LegacyLanguageRedirect() {
  const location = useLocation();
  const path = canonicalEnglishPath(location.pathname);
  return <Navigate to={`${path}${location.search}${location.hash}`} replace />;
}
